module.exports = __webpack_public_path__ + "img/RTX.44f87481.png";